import { render, staticRenderFns } from "./overseas_user.vue?vue&type=template&id=fffde118&scoped=true&"
import script from "./overseas_user.vue?vue&type=script&lang=js&"
export * from "./overseas_user.vue?vue&type=script&lang=js&"
import style0 from "./overseas_user.vue?vue&type=style&index=0&id=fffde118&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffde118",
  null
  
)

export default component.exports